import {ActionIconTheme} from './action-icon.tsx';
import {AnchorTheme} from './anchor.tsx';
import {AvatarTheme} from './avatar.tsx';
import {ButtonTheme} from './button.tsx';
import {CheckboxTheme} from './checkbox.tsx';
import {ComboboxTheme} from './combobox.tsx';
import {DatePickerTheme} from './date-picker.tsx';
import {DatePickerInputTheme} from './date-picker-input.tsx';
import {DateTimePickerTheme} from './date-time-picker.tsx';
import {InputTheme} from './input.tsx';
import {InputWrapperTheme} from './input-wrapper.tsx';
import {LoadingOverlayTheme} from './loading-overlay.tsx';
import {ModalTheme} from './modal.tsx';
import {NumberInputTheme} from './number-input.tsx';
import {PaginationTheme} from './pagination.tsx';
import {PillTheme} from './pill.tsx';
import {RatingTheme} from './rating.tsx';
import {SelectTheme} from './select.tsx';
import {SwitchTheme} from './switch.tsx';
import {TabsTheme} from './tabs.tsx';
import {TableTheme} from './table.tsx';
import {PaperTheme} from './paper.tsx';

export const ComponentsThemes = {
  ActionIcon: ActionIconTheme,
  Anchor: AnchorTheme,
  Avatar: AvatarTheme,
  Button: ButtonTheme,
  Checkbox: CheckboxTheme,
  Combobox: ComboboxTheme,
  DatePicker: DatePickerTheme,
  DatePickerInput: DatePickerInputTheme,
  DateTimePicker: DateTimePickerTheme,
  Input: InputTheme,
  InputWrapper: InputWrapperTheme,
  LoadingOverlay: LoadingOverlayTheme,
  Modal: ModalTheme,
  NumberInput: NumberInputTheme,
  Pagination: PaginationTheme,
  Paper: PaperTheme,
  Pill: PillTheme,
  Rating: RatingTheme,
  Select: SelectTheme,
  Switch: SwitchTheme,
  Tabs: TabsTheme,
  Table: TableTheme,
};